<!--<sub>Status</sub>-->
<div>
  {{line.variable.text}}
  <app-status-symbol [value]=TransformValue(itemValue)></app-status-symbol>
      <small>
<!--      <span><sup>R: {{ value.value }} </sup>-->
        {{ ValueAsText(itemValue) }}
<!--      <sub>T: {{ TransformValue(value.value) }}</sub>-->
<!--      </span>-->
    </small>
</div>












